module.exports = __webpack_public_path__ + "src/assets/img/06_wolken.5db70c0d.svg";